import { IDenovoIconComponentProps } from "../interfaces";

export const BondSingle = ({
  color = "currentColor",
  width = 24,
  height = 24,
  className,
}: IDenovoIconComponentProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      stroke={color}
      transform="rotate(-45)">
      <line
        x1="20%"
        y1="50%"
        x2="80%"
        y2="50%"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
};
